import { useMemo } from 'react';
import { observer } from 'mobx-react-lite';

import { TEntityGridConstraints } from 'app/common/entity-grid/core';
import * as EntityGrid from 'app/common/entity-grid/features';
import { HotFixEntityGridReadRequest } from 'app/common/entity-grid/features/entity-grid';
import { useUserRoles } from 'app/railways/domains/access/features/roles/use-user-roles';

import { getTariffTypesRequest } from '../../requests/get-tariff-types.request';
import { cols } from './tariffs-columns';

export const TariffsEntityGrid = observer(() => {
  const userRoles = useUserRoles();

  const initialConstraints = useMemo<TEntityGridConstraints>(
    () => ({
      sorting: [{ name: 'id', direction: 'descend' }],
    }),
    [],
  );

  return (
    <EntityGrid.Root
      columns={cols}
      rowModelType="largeList"
      recordsLimit={1000}
      initialState={initialConstraints}
      request={getTariffTypesRequest}
      userRoles={userRoles}
    >
      <div
        style={{
          display: 'flex',
          flexDirection: 'column',
          gap: 16,
          padding: 16,
          height: '100%',
        }}
      >
        <EntityGrid.NotificationsRender>
          {(notifications) => <div>{notifications}</div>}
        </EntityGrid.NotificationsRender>

        <HotFixEntityGridReadRequest />

        <div style={{ flexGrow: 1 }}>
          <EntityGrid.Table
            rowSelection="multiple"
            persistSettingsId="TariffsEntityGrid"
          />
        </div>
      </div>
    </EntityGrid.Root>
  );
});
